import React from "react";

/**
 * Rendered only when there is a choice to make: one currency needs no switch.
 * `label` names the group for assistive tech; the caller owns the (translated) word.
 */
export default function CurrencyPicker({ currencies, value, onChange, testid, label }) {
  if (!currencies || currencies.length < 2) return null;
  return (
    <div className="flex gap-1" role="group" aria-label={label} data-testid={`${testid}-currency-picker`}>
      {currencies.map((c) => (
        <button key={c} type="button" onClick={() => onChange(c)} data-testid={`${testid}-currency-${c}`}
          aria-pressed={c === value}
          className={`px-2.5 py-1 rounded-lg text-xs uppercase tracking-wider ${c === value ? "bg-sol-gold/15 text-amber-600 border border-sol-gold/30" : "bg-white text-slate-500 border border-slate-200"}`}>
          {c}
        </button>
      ))}
    </div>
  );
}
